import { BaseContainerModel } from "../base-container.model";
import { bl_wms_picking_list_hdr_RowInterface, bl_wms_picking_list_hdr_RowClass } from "../../dbschema/index";

export class WMSPickingListHdrContainer extends BaseContainerModel {
    bl_wms_picking_list_hdr: bl_wms_picking_list_hdr_RowInterface = new bl_wms_picking_list_hdr_RowClass();
}
